import Swal from "sweetalert2";
import { PandaboardApiInstance } from "helpers/api";
import { cleanUtmQueryParamsFromSession } from "helpers/queryParams";
import { Lead, LeadCreate, LeadResponse, LeadUpdate } from "../interfaces/lead.interface";
import { toLead } from "../helpers/formatData";
import { LeadErrorsEnum } from "../enums/lead.enums";

export const getLead = async (id: string): Promise<Lead> =>
  PandaboardApiInstance
    .get(`leads/${id}`)
    .then((res) => toLead(res.data))
    .catch((err: any) => {
      throw err.response.data;
    });

export const createLead = async (
  lead: LeadCreate
): Promise<Lead> => PandaboardApiInstance
  .post("leads", lead)
  .then((res) => toLead(res.data))
  .catch((err: any) => {
    throw err.response.data;
  })
  .finally(() => cleanUtmQueryParamsFromSession());

export const updateLead = async (
  id: string,
  lead: LeadUpdate
): Promise<Lead> => PandaboardApiInstance
  .put(`leads/${id}`, lead)
  .then((res) => toLead(res.data))
  .catch((err: any) => {
    if (err.response && err.response.status === 400) {
      let title;
      let text;

      if (err.response.data.message.startsWith(LeadErrorsEnum.CURP_ALREADY_EXISTS_IN_ANOTHER_OZONER)) {
        const maskedEmail = err.response.data.message.split(",")[1];
        title = "¡NO PODEMOS CONTINUAR CON ESTE CURP!";
        text = `El CURP que ingresaste ya está registrado con el correo ${maskedEmail}, que es diferente al que proporcionaste.`;

      } else if (err.response.data.message.startsWith(LeadErrorsEnum.EMAIL_ALREADY_EXISTS_IN_ANOTHER_OZONER)) {
        const maskedCurp = err.response.data.message.split(",")[1];
        title = "¡NO PODEMOS CONTINUAR CON ESTE CURP!";
        text = `Tu correo ya está registrado con el CURP ${maskedCurp}, que es diferente al que ingresaste.`;

      } else if (err.response.data.message === LeadErrorsEnum.CURP_AND_EMAIL_ALREADY_EXISTS_IN_ANOTHER_OZONER) {
        title = "¡TU CURP Y CORREO ELECTRÓNICO NO CONCUERDAN!";
        text = "El curp y correo electrónico diligenciado están asociados a dos cuentas diferentes.";

      } else {
        title = "Ha ocurrido un error";
        text = "No se ha podido generar la actualización del lead";

      }

      Swal.fire({
        text,
        title,
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "bg_primary_300 w_90_per",
          title: "text_neutral_800",
          container: "text_neutral_700",
        },
      });
    }
    throw err.response.data;
  })
  .finally(() => cleanUtmQueryParamsFromSession());

export const completeLead = async (
  id: string,
  lead: LeadUpdate
): Promise<{ ozoner: any, financialForm: any}> => PandaboardApiInstance
  .put(`leads/${id}`, lead)
  .then((res) => res.data)
  .catch((err: any) => {
    if (err.response) {
      Swal.fire({
        title: "Ha ocurrido un error",
        text: `No se ha podido crear la solicitud. Error: ${err.response.data.message}`,
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
    throw err.response.data;
  })
  .finally(() => cleanUtmQueryParamsFromSession());

export const FilterLeadByEmail = async (
  email: string
): Promise<Lead[]> => PandaboardApiInstance
  .get(`leads/email/${email}`)
  .then((res) => res.data.map((lead: LeadResponse) => toLead(lead)))
  .catch((err: any) => {
    throw err.response.data;
  });
